(function () {
  function money(cents) {
    var val = Math.round(cents / 100);
    return '₹' + val.toLocaleString('en-IN');
  }

  function init() {
    var pdp = document.getElementById('pdp');
    if (!pdp) return;

    var jsonEl = pdp.parentElement.querySelector('script[id^="ProductJson-"]') || document.querySelector('script[id^="ProductJson-"]');
    var product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var truePricesEl = document.getElementById('TruePrices-' + product.id);
    var truePrices = {};
    if (truePricesEl) { try { truePrices = JSON.parse(truePricesEl.textContent); } catch (e) {} }

    var qtyBoundsEl = document.getElementById('QtyBounds-' + product.id);
    var qtyBoundsMap = {};
    if (qtyBoundsEl) { try { qtyBoundsMap = JSON.parse(qtyBoundsEl.textContent); } catch (e) {} }

    /* ---- Gallery ---- */
    var mainImgs = document.querySelectorAll('.pdp-main-img-el');
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var dots = document.querySelectorAll('.pdp-img-dot');

    function showMedia(index) {
      mainImgs.forEach(function (img) {
        var match = img.dataset.mediaIndex === String(index);
        img.style.display = match ? '' : 'none';
        img.classList.toggle('active', match);
      });
      thumbs.forEach(function (t) { t.classList.toggle('active', t.dataset.mediaIndex === String(index)); });
      dots.forEach(function (d) { d.classList.toggle('active', d.dataset.mediaIndex === String(index)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaIndex); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { showMedia(d.dataset.mediaIndex); }); });

    /* ---- Qty stepper ---- */
    /* #qty-num displays PIECES; #qty-real (hidden) holds the actual variant quantity
       that gets submitted to the cart. For products without a "Quantity" tier option,
       piecesPerUnit is always 1, so display === real and nothing changes.

       For range-priced products (variants carrying custom.qty_min/qty_max metafields,
       e.g. "Up to 12 Pieces" @ RP / "Bulk 13+ Pieces" @ QP+5%), qtyMin/qtyMax span the
       UNION of every price-bracket variant sharing the same non-Quantity options — one
       continuous stepper the shopper can run straight through 1, 2, 3…12, 13, 14… — and
       activeVariant/applyVariant auto-switch to whichever bracket the typed quantity
       falls into, updating price live, with no separate tier button to click. Falls
       back to the original moq×piecesPerUnit / 9999 bounds and manual tier-button
       selection for products that don't define these metafields, so existing pack-tier
       products (bedsheets, towels, door mats, stools) are unaffected. */
    var qtyEl = document.getElementById('qty-num');
    var qtyRealEl = document.getElementById('qty-real');
    var addBtn = document.getElementById('pdp-add');
    var mobileAddBtn = document.getElementById('pdp-mobile-add');
    var packNoteEl = document.getElementById('pdp-pack-note');

    function setLabel(btn, text) {
      if (!btn) return;
      var svg = btn.querySelector('svg');
      btn.textContent = text;
      if (svg) btn.prepend(svg);
    }

    function syncQty() {
      var real = qtyRealEl ? qtyRealEl.value : qtyEl.value;
      if (addBtn) addBtn.dataset.qty = real;
      if (mobileAddBtn) mobileAddBtn.dataset.qty = real;
    }
    /* Recomputes the headline price, mobile price, and CTA text on every stepper
       click for pack-tier products that have a "Bulk Topper" variant. Leftover
       pieces beyond whole packs are priced at the exact per-piece bulk rate and
       get added to the cart as a second line item (see theme.js), so the price
       shown always exactly matches what gets charged, for any quantity. Products
       without a topper variant (or the qty_min/qty_max bracket system below) are
       unaffected and keep their existing behavior. */
    function updatePriceTotal() {
      var totalEl = document.getElementById('pdp-price-total');
      var priceEl = document.getElementById('pdp-price');
      var mobilePriceEl = document.getElementById('pdp-mobile-price');
      if (!activeVariant) { if (totalEl) totalEl.style.display = 'none'; return; }
      var pieces = parseInt(qtyEl ? qtyEl.value : '1', 10) || 1;
      var truePrice = truePrices[String(activeVariant.id)] || 0;
      var hasDepositPlan = truePrice > 0;
      var topper = findTopperVariant(activeVariant);

      if (topper) {
        var packs = Math.floor(pieces / piecesPerUnit);
        var extra = pieces - packs * piecesPerUnit;
        var topperTrue = truePrices[String(topper.id)] || 0;
        var displayTotal = (hasDepositPlan ? truePrice : activeVariant.price) * packs + (hasDepositPlan ? topperTrue : topper.price) * extra;
        var depositTotal = activeVariant.price * packs + topper.price * extra;

        if (priceEl) priceEl.textContent = money(displayTotal);
        if (mobilePriceEl) mobilePriceEl.textContent = money(depositTotal);
        if (addBtn && !addBtn.disabled) setLabel(addBtn, hasDepositPlan ? ('Book the Order at Only ' + money(depositTotal)) : 'Add to Order');
        if (mobileAddBtn && !mobileAddBtn.disabled) setLabel(mobileAddBtn, hasDepositPlan ? ('Book at Only ' + money(depositTotal)) : 'Add to Order');

        [addBtn, mobileAddBtn].forEach(function (btn) {
          if (!btn) return;
          btn.dataset.qty = packs;
          if (extra > 0) { btn.dataset.extraVariantId = topper.id; btn.dataset.extraQty = extra; }
          else { delete btn.dataset.extraVariantId; delete btn.dataset.extraQty; }
        });

        if (totalEl) totalEl.style.display = 'none';
        return;
      }

      [addBtn, mobileAddBtn].forEach(function (btn) { if (btn) { delete btn.dataset.extraVariantId; delete btn.dataset.extraQty; } });

      if (!totalEl) return;
      if (piecesPerUnit !== 1) { totalEl.style.display = 'none'; return; }
      var unitCents = activeVariant.price;
      var totalCents = unitCents * pieces;
      totalEl.style.display = '';
      totalEl.textContent = (hasDepositPlan ? 'Deposit due: ' : '') + pieces + ' × ' + money(unitCents) + ' = ' + money(totalCents);
    }
    var qtyWrap = document.querySelector('.pdp-qty-wrap');
    var moq = qtyWrap ? (parseInt(qtyWrap.dataset.moq, 10) || 1) : 1;
    var piecesPerUnit = qtyWrap ? (parseInt(qtyWrap.dataset.piecesPerUnit, 10) || 1) : 1;
    var qtyMin = qtyWrap ? (parseInt(qtyWrap.dataset.qtyMin, 10) || (moq * piecesPerUnit)) : (moq * piecesPerUnit);
    var qtyMax = qtyWrap ? (parseInt(qtyWrap.dataset.qtyMax, 10) || 9999) : 9999;
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus = document.getElementById('qty-plus');
    var qtyShortcuts = document.querySelectorAll('.pdp-qty-sc');
    var activeVariant = (product.variants || []).find(function (v) {
      return String(v.id) === (addBtn && addBtn.dataset.variantId);
    }) || (product.variants && product.variants[0]);

    function syncRealFromDisplay() {
      /* Display moves in single-piece steps; the real submitted quantity (packs)
         only advances once the displayed pieces cross a full pack boundary, so the
         charge always matches a whole number of packs (never a partial pack). */
      var floor = qtyMin;
      var pieces = parseInt(qtyEl.value, 10) || floor;
      if (pieces < floor) pieces = floor;
      if (pieces > qtyMax) pieces = qtyMax;
      qtyEl.value = pieces;

      if (activeVariant) {
        var target = findVariantForPieces(pieces, activeVariant);
        if (target && String(target.id) !== String(activeVariant.id)) {
          applyVariant(target, { keepQty: true });
        }
      }

      var realPacks = Math.max(moq, Math.ceil(pieces / piecesPerUnit));
      if (qtyRealEl) qtyRealEl.value = realPacks;
      syncQty();
      updatePriceTotal();
    }
    function syncShortcuts() {
      var q = parseInt(qtyEl.value, 10) || qtyMin;
      qtyShortcuts.forEach(function (b) { b.classList.toggle('active', parseInt(b.dataset.qty, 10) === q); });
    }
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var floor = qtyMin;
      qtyEl.value = Math.max(floor, (parseInt(qtyEl.value, 10) || floor) - 1);
      syncRealFromDisplay(); syncShortcuts();
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qtyEl.value = Math.min(qtyMax, (parseInt(qtyEl.value, 10) || qtyMin) + 1);
      syncRealFromDisplay(); syncShortcuts();
    });
    qtyShortcuts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyEl.value = parseInt(btn.dataset.qty, 10) || qtyMin;
        syncRealFromDisplay();
        syncShortcuts();
      });
    });

    /* ---- Bulk quantity tiers (informational estimate, real checkout price is the product's Shopify price) ---- */
    var tiersWrap = document.getElementById('pdp-tiers');
    var tierTotalEl = document.getElementById('pdp-tier-total');
    function updateTierTotal() {
      if (!tiersWrap || !tierTotalEl) return;
      var active = tiersWrap.querySelector('.pdp-tier.active');
      if (!active) return;
      var price = parseInt(active.dataset.price, 10) || 0;
      var qty = parseInt(qtyEl.value, 10) || 1;
      tierTotalEl.textContent = '₹' + (price * qty).toLocaleString('en-IN') + ' for ' + qty + ' pcs';
    }
    if (tiersWrap) {
      tiersWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-tier');
        if (!btn) return;
        tiersWrap.querySelectorAll('.pdp-tier').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        var min = parseInt(btn.dataset.qtyMin, 10);
        if (min && (parseInt(qtyEl.value, 10) || 0) < min) { qtyEl.value = min; syncQty(); }
        updateTierTotal();
      });
      qtyEl.addEventListener('input', updateTierTotal);
      if (qtyMinus) qtyMinus.addEventListener('click', updateTierTotal);
      if (qtyPlus) qtyPlus.addEventListener('click', updateTierTotal);
      updateTierTotal();
    }

    /* ---- Option / variant matching ---- */
    var optionGroups = document.querySelectorAll('.pdp-opt-group');
    function currentSelection() {
      var sel = [];
      optionGroups.forEach(function (group) {
        var idxAttr = group.dataset.optionIndex;
        if (idxAttr === undefined) return;
        var idx = parseInt(idxAttr, 10);
        if (isNaN(idx)) return;
        var active = group.querySelector('.pdp-opt-btn.active');
        sel[idx] = active ? active.dataset.value : null;
      });
      return sel;
    }
    function findVariant(selection) {
      return product.variants.find(function (v) {
        return selection.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    var qtyOptionIndex = -1;
    if (product.options) {
      product.options.forEach(function (name, i) {
        if (/quantity/i.test(name)) qtyOptionIndex = i;
      });
    }
    function parsePieces(optionValue) {
      var m = /^(\d+)\s*Piece/i.exec(optionValue || '');
      return m ? parseInt(m[1], 10) : null;
    }
    /* A "Bulk Topper" variant is a hidden, single-piece variant priced at the
       bulk per-piece rate (pack price / pack size). It never appears as a
       selectable option (filtered out in main-product.liquid), but when one
       exists for the current variant's pack, it lets the cart charge the
       exact per-piece rate for quantities that aren't a multiple of the pack
       size, instead of silently rounding up to a full extra pack. */
    function findTopperVariant(variant) {
      if (!variant || qtyOptionIndex === -1) return null;
      return product.variants.find(function (v) {
        var qv = v.options[qtyOptionIndex];
        if (typeof qv !== 'string' || qv.indexOf('Bulk Topper') === -1) return false;
        return v.options.every(function (val, i) { return i === qtyOptionIndex || val === variant.options[i]; });
      }) || null;
    }
    function moqLabel(variant) {
      if (qtyOptionIndex === -1) return null;
      var candidates = product.variants.filter(function (v) {
        return v.available && v.options.every(function (val, i) { return i === qtyOptionIndex || val === variant.options[i]; });
      });
      var pieceCounts = candidates.map(function (v) { return parsePieces(v.options[qtyOptionIndex]); }).filter(Boolean);
      if (!pieceCounts.length) return null;
      return 'Minimum Order Quantity: ' + Math.min.apply(null, pieceCounts) + ' pcs';
    }

    /* Range-priced quantity brackets (custom.qty_min / custom.qty_max metafields).
       computeQtyRange spans every bracket sharing the same non-Quantity options, so
       the stepper covers the whole range in one go. findVariantForPieces resolves
       which bracket a given piece count belongs to (falls back to the top/bottom
       bracket if the count is outside every defined range). syncOptionUI keeps the
       Quantity pill buttons' active/label state in sync when the bracket auto-switches. */
    function computeQtyRange(variant) {
      if (qtyOptionIndex === -1 || !variant) return null;
      var matches = product.variants.filter(function (v) {
        return v.options.every(function (val, i) { return i === qtyOptionIndex || val === variant.options[i]; });
      });
      var mins = [], maxs = [];
      matches.forEach(function (v) {
        var b = qtyBoundsMap[String(v.id)];
        if (b && (b.min || b.max)) { mins.push(b.min || 1); maxs.push(b.max || 9999); }
      });
      if (!mins.length) return null;
      return { min: Math.min.apply(null, mins), max: Math.max.apply(null, maxs) };
    }
    function findVariantForPieces(pieces, refVariant) {
      if (qtyOptionIndex === -1 || !refVariant) return null;
      var matches = product.variants.filter(function (v) {
        return v.options.every(function (val, i) { return i === qtyOptionIndex || val === refVariant.options[i]; });
      });
      var withBounds = matches.filter(function (v) { var b = qtyBoundsMap[String(v.id)]; return b && (b.min || b.max); });
      if (!withBounds.length) return null;
      var exact = null;
      withBounds.forEach(function (v) {
        var b = qtyBoundsMap[String(v.id)];
        var lo = b.min || 1, hi = b.max || Infinity;
        if (pieces >= lo && pieces <= hi) exact = v;
      });
      if (exact) return exact;
      withBounds.sort(function (a, b) { return (qtyBoundsMap[String(a.id)].min || 1) - (qtyBoundsMap[String(b.id)].min || 1); });
      var top = withBounds[withBounds.length - 1];
      return pieces > (qtyBoundsMap[String(top.id)].min || 1) ? top : withBounds[0];
    }
    function syncOptionUI(variant) {
      optionGroups.forEach(function (group) {
        var idxAttr = group.dataset.optionIndex;
        if (idxAttr === undefined) return;
        var idx = parseInt(idxAttr, 10);
        if (isNaN(idx)) return;
        var val = variant.options[idx];
        var label = group.querySelector('.pdp-opt-selected');
        if (label && val !== undefined) label.textContent = val;
        group.querySelectorAll('.pdp-opt-btn[data-value]').forEach(function (b) {
          b.classList.toggle('active', b.dataset.value === val);
        });
      });
    }

    /* Widen the stepper at load time to the full range spanning every bracket, not
       just the initially-selected variant's own narrower bounds. */
    var initialRange = computeQtyRange(activeVariant);
    if (initialRange) {
      qtyMin = initialRange.min;
      qtyMax = initialRange.max;
      if (qtyWrap) { qtyWrap.dataset.qtyMin = String(qtyMin); qtyWrap.dataset.qtyMax = String(qtyMax); }
      if (qtyEl) { qtyEl.min = qtyMin; qtyEl.max = qtyMax; }
    }

    function applyVariant(variant, opts) {
      if (!variant) return;
      opts = opts || {};
      activeVariant = variant;
      var priceEl = document.getElementById('pdp-price');
      var mrpEl = document.getElementById('pdp-mrp');
      var saveEl = document.getElementById('pdp-save');
      var stockEl = document.getElementById('pdp-stock-label');
      var mobilePriceEl = document.getElementById('pdp-mobile-price');

      var truePrice = truePrices[String(variant.id)] || 0;
      var hasDepositPlan = truePrice > 0;
      if (priceEl) priceEl.textContent = hasDepositPlan ? money(truePrice) : money(variant.price);
      if (mobilePriceEl) mobilePriceEl.textContent = money(variant.price);
      var savePct = 0;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        savePct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      }
      if (mrpEl && saveEl) {
        if (savePct > 0) {
          mrpEl.textContent = money(variant.compare_at_price);
          saveEl.textContent = 'Save ' + savePct + '%';
          mrpEl.style.display = '';
          saveEl.style.display = '';
        } else {
          mrpEl.style.display = 'none';
          saveEl.style.display = 'none';
        }
      }
      var unavailableLabel = variant.available ? null : (moqLabel(variant) || 'Sold Out');
      var singlePieceQty = qtyOptionIndex > -1 ? parsePieces(variant.options[qtyOptionIndex]) : null;
      var forceMinOrder = singlePieceQty === 1;

      piecesPerUnit = singlePieceQty || 1;
      if (qtyWrap) qtyWrap.dataset.piecesPerUnit = String(piecesPerUnit);

      var range = computeQtyRange(variant);
      if (range) {
        qtyMin = range.min;
        qtyMax = range.max;
      } else {
        qtyMin = moq * piecesPerUnit;
        qtyMax = 9999;
      }
      if (qtyWrap) { qtyWrap.dataset.qtyMin = String(qtyMin); qtyWrap.dataset.qtyMax = String(qtyMax); }

      if (qtyEl) {
        if (!opts.keepQty) {
          var bounds = qtyBoundsMap[String(variant.id)];
          qtyEl.value = (bounds && bounds.min) ? bounds.min : qtyMin;
        }
        qtyEl.min = qtyMin;
        qtyEl.max = qtyMax;
        if (!opts.keepQty) {
          if (qtyRealEl) qtyRealEl.value = Math.max(moq, Math.ceil(qtyEl.value / piecesPerUnit));
          syncQty();
          syncShortcuts();
        }
      }
      updatePriceTotal();
      if (packNoteEl) {
        if (piecesPerUnit > 1) { packNoteEl.style.display = ''; packNoteEl.textContent = piecesPerUnit + ' pcs / pack'; }
        else { packNoteEl.style.display = 'none'; }
      }

      if (stockEl) stockEl.textContent = forceMinOrder ? 'Minimum order 12 pcs' : (variant.available ? 'In Stock' : unavailableLabel);

      var btnDisabled = forceMinOrder || !variant.available;
      [addBtn, mobileAddBtn].forEach(function (btn) {
        if (!btn) return;
        btn.dataset.variantId = variant.id;
        btn.disabled = btnDisabled;
        btn.style.opacity = btnDisabled ? '.5' : '';
        btn.style.cursor = btnDisabled ? 'not-allowed' : '';
      });
      var availableLabel = hasDepositPlan ? ('Book the Order at Only ' + money(variant.price)) : (isBundleMode ? 'Add to Bundle' : 'Add to Order');
      var mobileAvailableLabel = hasDepositPlan ? ('Book at Only ' + money(variant.price)) : (isBundleMode ? 'Add to Bundle' : 'Add to Order');
      var minOrderLabel = 'Minimum order 12 pcs';
      if (addBtn) {
        var svg = addBtn.querySelector('svg');
        addBtn.textContent = forceMinOrder ? minOrderLabel : (variant.available ? availableLabel : unavailableLabel);
        if (svg) addBtn.prepend(svg);
      }
      if (mobileAddBtn) mobileAddBtn.textContent = forceMinOrder ? minOrderLabel : (variant.available ? mobileAvailableLabel : unavailableLabel);

      syncOptionUI(variant);

      if (variant.featured_media) {
        var idx = product.media.findIndex(function (m) { return m.id === variant.featured_media.id; });
        if (idx > -1) showMedia(idx);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-opt-btn');
        if (!btn) return;
        group.querySelectorAll('.pdp-opt-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var label = group.querySelector('.pdp-opt-selected');
        if (label) label.textContent = btn.dataset.value;
        var variant = findVariant(currentSelection());
        if (variant) applyVariant(variant);
      });
    });

    /* ---- Colour preference (informational only — not a Shopify variant/option;
       stored as a cart line-item property so the shopper's pick shows up on the order) ---- */
    var colorRow = document.getElementById('pdp-color-row');
    if (colorRow) {
      var colorSelectedLabel = document.getElementById('pdp-color-selected');
      var colorValueInput = document.getElementById('pdp-color-value');
      colorRow.addEventListener('click', function (e) {
        var circle = e.target.closest('.pdp-color-circle');
        if (!circle) return;
        colorRow.querySelectorAll('.pdp-color-circle').forEach(function (c) { c.classList.remove('active'); });
        circle.classList.add('active');
        var hex = circle.dataset.hex || '';
        if (colorValueInput) colorValueInput.value = hex;
        if (colorSelectedLabel) colorSelectedLabel.textContent = hex ? hex : 'Assorted (any colour)';
        [addBtn, mobileAddBtn].forEach(function (btn) {
          if (!btn) return;
          if (hex) { btn.dataset.color = hex; } else { delete btn.dataset.color; }
        });
        if (circle.dataset.mediaIndex !== undefined) { showMedia(circle.dataset.mediaIndex); }
      });
    }

    syncQty();
    updatePriceTotal();

    /* ==========================================
       RESELL DUMMY-BUNDLE SIDE PANEL
       Only active on product pages configured with a "Build a Bundle" link
       (section.settings.bundle_url, rendered as data-bundle-mode="1" on #pdp).
       Items added here do NOT go to the real Shopify cart — they accumulate in
       localStorage (so the bundle persists across different product pages) and
       only get pushed to the real cart, all at once, once the running piece
       total reaches the bundle minimum.
       ========================================== */
    var isBundleMode = pdp.dataset.bundleMode === '1';
    if (isBundleMode) {
      var BUNDLE_MOQ = parseInt(pdp.dataset.bundleMoq, 10) || 9;
      var BUNDLE_URL = pdp.dataset.bundleUrl || '/pages/resell-bundle';
      var BUNDLE_KEY = 'clover_resell_bundle';

      var loadBundle = function () {
        try { return JSON.parse(localStorage.getItem(BUNDLE_KEY)) || []; } catch (e) { return []; }
      };
      var saveBundle = function (items) {
        try { localStorage.setItem(BUNDLE_KEY, JSON.stringify(items)); } catch (e) {}
      };
      var bundleTotalPieces = function (items) {
        return items.reduce(function (s, it) { return s + it.qty; }, 0);
      };
      var bundleTotalPrice = function (items) {
        return items.reduce(function (s, it) { return s + it.qty * it.price; }, 0);
      };

      var rbpOverlay, rbpItemsEl, rbpEmptyEl, rbpCountEl, rbpFillEl, rbpStatusEl, rbpFootEl, rbpTotalEl, rbpPlaceBtn;
      var rbpFab, rbpFabCount;

      var closeRbp = function () {
        if (!rbpOverlay) return;
        rbpOverlay.classList.remove('active');
        document.body.style.overflow = '';
      };

      var updateFab = function (items) {
        if (!rbpFab) return;
        var pieces = bundleTotalPieces(items);
        rbpFab.style.display = pieces > 0 ? 'flex' : 'none';
        if (rbpFabCount) rbpFabCount.textContent = pieces;
      };

      var renderRbp = function (items) {
        ensureRbpDom();
        var pieces = bundleTotalPieces(items);
        var pct = Math.min(100, (pieces / BUNDLE_MOQ) * 100);
        rbpCountEl.textContent = pieces + ' / ' + BUNDLE_MOQ + ' pcs';
        rbpFillEl.style.width = pct + '%';
        rbpStatusEl.textContent = pieces === 0 ? 'Pick pieces from any product' : pieces < BUNDLE_MOQ ? (BUNDLE_MOQ - pieces) + ' more pieces to unlock your order' : 'Ready to place your order!';
        rbpStatusEl.className = 'rbp-status ' + (pieces === 0 ? '' : pieces < BUNDLE_MOQ ? 'partial' : 'ready');

        if (!items.length) {
          rbpEmptyEl.style.display = '';
          rbpItemsEl.innerHTML = '';
          rbpFootEl.style.display = 'none';
          updateFab(items);
          return;
        }
        rbpEmptyEl.style.display = 'none';
        rbpFootEl.style.display = '';
        rbpTotalEl.textContent = money(bundleTotalPrice(items));
        rbpItemsEl.innerHTML = items.map(function (it) {
          var img = it.image ? '<img src="' + it.image + '" alt="" class="rbp-item-img">' : '<div class="rbp-item-img rbp-item-img-ph"></div>';
          var variant = it.variantTitle ? '<div class="rbp-item-variant">' + it.variantTitle + '</div>' : '';
          return '<div class="rbp-item">' + img +
            '<div class="rbp-item-info">' +
              '<div class="rbp-item-name">' + it.productTitle + '</div>' +
              variant +
              '<div class="rbp-item-qty">' + it.qty + ' × ' + money(it.price) + '</div>' +
            '</div>' +
            '<div class="rbp-item-right">' +
              '<div class="rbp-item-price">' + money(it.qty * it.price) + '</div>' +
              '<button type="button" class="rbp-item-remove" data-rbp-remove="' + it.variantId + '">Remove</button>' +
            '</div>' +
          '</div>';
        }).join('');

        var ready = pieces >= BUNDLE_MOQ;
        rbpPlaceBtn.disabled = !ready;
        rbpPlaceBtn.classList.toggle('ready', ready);
        rbpPlaceBtn.textContent = ready ? 'Place Order — ' + pieces + ' pcs' : 'Add ' + (BUNDLE_MOQ - pieces) + ' more pieces to place order';
        updateFab(items);
      };

      var openRbp = function () {
        ensureRbpDom();
        rbpOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      };

      var placeBundleOrder = function () {
        var items = loadBundle();
        if (bundleTotalPieces(items) < BUNDLE_MOQ) return;
        rbpPlaceBtn.disabled = true;
        rbpPlaceBtn.textContent = 'Placing order…';
        var payload = items.map(function (it) { return { id: parseInt(it.variantId, 10), quantity: it.qty }; });
        var addUrl = (document.body && document.body.dataset.cartAddUrl) || '/cart/add.js';
        var cartUrl = (document.body && document.body.dataset.cartUrl) || '/cart';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: payload })
        }).then(function (r) { return r.json(); }).then(function () {
          saveBundle([]);
          window.location.href = cartUrl;
        }).catch(function () {
          rbpPlaceBtn.disabled = false;
          rbpPlaceBtn.textContent = 'Something went wrong — try again';
        });
      };

      function ensureRbpDom() {
        if (rbpOverlay) return;
        rbpOverlay = document.createElement('div');
        rbpOverlay.className = 'rbp-overlay';
        rbpOverlay.innerHTML =
          '<aside class="rbp-panel" role="dialog" aria-label="Your Bundle">' +
            '<div class="rbp-head">' +
              '<div class="rbp-head-title">Your Bundle<span class="rbp-head-count" id="rbp-count">0 pcs</span></div>' +
              '<button type="button" class="rbp-close" id="rbp-close" aria-label="Close">✕</button>' +
            '</div>' +
            '<div class="rbp-progress">' +
              '<div class="rbp-track"><div class="rbp-fill" id="rbp-fill"></div></div>' +
              '<div class="rbp-status" id="rbp-status"></div>' +
            '</div>' +
            '<div class="rbp-body">' +
              '<div class="rbp-empty" id="rbp-empty"><div class="rbp-empty-icon">🎁</div><p>Add pieces from any product to build your bundle.</p></div>' +
              '<div class="rbp-items" id="rbp-items"></div>' +
            '</div>' +
            '<div class="rbp-foot" id="rbp-foot" style="display:none">' +
              '<div class="rbp-subtotal"><span>Estimated Total</span><span id="rbp-total-amount">₹0</span></div>' +
              '<button type="button" class="rbp-place-btn" id="rbp-place-btn" disabled>Add ' + BUNDLE_MOQ + ' pieces to place order</button>' +
              '<a href="' + BUNDLE_URL + '" class="rbp-continue">Browse Full Catalog →</a>' +
            '</div>' +
          '</aside>';
        document.body.appendChild(rbpOverlay);
        rbpItemsEl = rbpOverlay.querySelector('#rbp-items');
        rbpEmptyEl = rbpOverlay.querySelector('#rbp-empty');
        rbpCountEl = rbpOverlay.querySelector('#rbp-count');
        rbpFillEl = rbpOverlay.querySelector('#rbp-fill');
        rbpStatusEl = rbpOverlay.querySelector('#rbp-status');
        rbpFootEl = rbpOverlay.querySelector('#rbp-foot');
        rbpTotalEl = rbpOverlay.querySelector('#rbp-total-amount');
        rbpPlaceBtn = rbpOverlay.querySelector('#rbp-place-btn');

        rbpOverlay.addEventListener('click', function (e) { if (e.target === rbpOverlay) closeRbp(); });
        rbpOverlay.querySelector('#rbp-close').addEventListener('click', closeRbp);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeRbp(); });

        rbpItemsEl.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-rbp-remove]');
          if (!btn) return;
          var key = btn.dataset.rbpRemove;
          var items = loadBundle().filter(function (it) { return it.variantId !== key; });
          saveBundle(items);
          renderRbp(items);
        });

        rbpPlaceBtn.addEventListener('click', placeBundleOrder);
      }

      var addToBundle = function () {
        var qty = parseInt(qtyRealEl ? qtyRealEl.value : (qtyEl ? qtyEl.value : 1), 10) || 1;
        var variant = activeVariant;
        if (!variant) return;
        var items = loadBundle();
        var existing = items.find(function (it) { return it.variantId === String(variant.id); });
        if (existing) {
          existing.qty += qty;
        } else {
          items.push({
            variantId: String(variant.id),
            productTitle: product.title,
            variantTitle: (variant.title && variant.title !== 'Default Title') ? variant.title : '',
            qty: qty,
            price: variant.price,
            image: pdp.dataset.productImage || '',
            url: pdp.dataset.productUrl || product.url || ''
          });
        }
        saveBundle(items);
        renderRbp(items);
        openRbp();
      };

      [addBtn, mobileAddBtn].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          addToBundle();
        });
      });

      /* Floating reopen chip so the in-progress bundle stays reachable while browsing other products */
      rbpFab = document.createElement('button');
      rbpFab.type = 'button';
      rbpFab.className = 'rbp-fab';
      rbpFab.innerHTML = '🎁 <span id="rbp-fab-count">0</span> pcs';
      rbpFabCount = null;
      rbpFab.addEventListener('click', function () { renderRbp(loadBundle()); openRbp(); });
      document.body.appendChild(rbpFab);
      rbpFabCount = document.getElementById('rbp-fab-count');

      renderRbp(loadBundle());
    }

    /* ---- Accordion ---- */
    document.querySelectorAll('.pdp-acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pdp-acc-item');
        var open = item.classList.contains('open');
        document.querySelectorAll('.pdp-acc-item').forEach(function (i) { i.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });

    initReviews();
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function starString(rating) {
    var r = Math.round(rating);
    return '★'.repeat(r) + '☆'.repeat(5 - r);
  }

  function injectReviewSchema(section, data) {
    if (!data.count) return;
    var existing = document.getElementById('pdp-review-schema');
    if (existing) existing.remove();
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: section.dataset.productTitle,
      url: section.dataset.productUrl,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: data.average,
        reviewCount: data.count,
      },
      review: data.reviews.slice(0, 10).map(function (r) {
        return {
          '@type': 'Review',
          author: { '@type': 'Person', name: r.author_name },
          datePublished: r.created_at.slice(0, 10),
          reviewRating: { '@type': 'Rating', ratingValue: r.rating },
          reviewBody: r.body,
          name: r.title || undefined,
        };
      }),
    };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'pdp-review-schema';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function renderReviewSummary(data) {
    var summaryEl = document.getElementById('pdp-reviews-summary');
    if (!summaryEl) return;
    if (data.count > 0) {
      summaryEl.innerHTML = '<span class="stars">' + starString(data.average) + '</span> ' + data.average + ' out of 5 (' + data.count + ' review' + (data.count === 1 ? '' : 's') + ')';
    } else {
      summaryEl.textContent = 'No reviews yet — be the first to review this product.';
    }
  }

  function renderReviewList(data) {
    var listEl = document.getElementById('pdp-review-list');
    if (!listEl) return;
    if (!data.count) {
      listEl.innerHTML = '<p class="pdp-review-empty">No reviews yet. Be the first to share your experience with this product.</p>';
      return;
    }
    listEl.innerHTML = data.reviews.map(function (r) {
      var date = new Date(r.created_at);
      var dateStr = isNaN(date) ? '' : date.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
      return '<div class="pdp-review-item">' +
        '<div class="pdp-review-item-head">' +
          '<span class="pdp-review-item-stars">' + starString(r.rating) + '</span>' +
          '<span class="pdp-review-item-author">' + escapeHtml(r.author_name) + '</span>' +
          '<span class="pdp-review-item-date">' + dateStr + '</span>' +
        '</div>' +
        (r.title ? '<div class="pdp-review-item-title">' + escapeHtml(r.title) + '</div>' : '') +
        '<div class="pdp-review-item-body">' + escapeHtml(r.body) + '</div>' +
        '</div>';
    }).join('');
  }

  function initReviews() {
    var section = document.getElementById('pdp-reviews');
    if (!section) return;
    var api = section.dataset.reviewsApi;
    var handle = section.dataset.productHandle;
    var form = document.getElementById('pdp-review-form');
    var openBtn = document.getElementById('pdp-review-open-form');
    var starPicker = document.getElementById('pdp-star-picker');
    var statusEl = document.getElementById('pdp-review-status');
    var selectedRating = 0;

    function loadReviews() {
      fetch(api + '/reviews?product=' + encodeURIComponent(handle))
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function (data) {
          renderReviewSummary(data);
          renderReviewList(data);
          injectReviewSchema(section, data);
        })
        .catch(function () {
          var listEl = document.getElementById('pdp-review-list');
          if (listEl) listEl.innerHTML = '';
          var summaryEl = document.getElementById('pdp-reviews-summary');
          if (summaryEl) summaryEl.textContent = '';
        });
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        form.hidden = !form.hidden;
        openBtn.textContent = form.hidden ? 'Write a Review' : 'Cancel';
      });
    }

    if (starPicker) {
      starPicker.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedRating = parseInt(btn.dataset.star, 10);
          starPicker.querySelectorAll('button').forEach(function (b) {
            b.classList.toggle('active', parseInt(b.dataset.star, 10) <= selectedRating);
          });
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        statusEl.className = '';
        statusEl.textContent = '';

        if (!selectedRating) {
          statusEl.className = 'error';
          statusEl.textContent = 'Please select a star rating.';
          return;
        }
        var bodyVal = document.getElementById('pdp-review-body').value.trim();
        var nameVal = document.getElementById('pdp-review-name').value.trim();
        if (bodyVal.length < 10) {
          statusEl.className = 'error';
          statusEl.textContent = 'Please write a bit more detail (at least 10 characters).';
          return;
        }

        var submitBtn = document.getElementById('pdp-review-submit');
        submitBtn.disabled = true;
        statusEl.textContent = 'Submitting…';

        fetch(api + '/reviews', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            product_handle: handle,
            product_title: section.dataset.productTitle,
            rating: selectedRating,
            title: document.getElementById('pdp-review-title').value.trim(),
            body: bodyVal,
            author_name: nameVal,
            author_email: document.getElementById('pdp-review-email').value.trim(),
            hp: document.getElementById('pdp-review-hp').value,
          }),
        })
          .then(function (res) { return res.ok ? res.json() : res.json().then(function (d) { return Promise.reject(d); }); })
          .then(function () {
            statusEl.className = 'success';
            statusEl.textContent = 'Thanks! Your review is live.';
            form.reset();
            selectedRating = 0;
            starPicker.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
            loadReviews();
            setTimeout(function () { form.hidden = true; if (openBtn) openBtn.textContent = 'Write a Review'; }, 1500);
          })
          .catch(function (err) {
            statusEl.className = 'error';
            statusEl.textContent = (err && err.error === 'rate_limited') ? 'Too many reviews submitted — please try again later.' : 'Something went wrong. Please try again.';
          })
          .finally(function () {
            submitBtn.disabled = false;
          });
      });
    }

    loadReviews();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
